import React, { useEffect } from "react";
import "./VoteModal.css";

function ConfirmModal({ isOpen, onClose, onConfirm, title, message, confirmText = "Confirmar", cancelText = "Cancelar", isDanger = false }) {
  // Bloquear scroll quando modal abrir
  useEffect(() => {
    if (isOpen) {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content" style={{ maxWidth: "600px" }}>
        <div className="modal-header">
          <h2 className="modal-title">
            {isDanger ? <span>⚠️</span> : <span>❓</span>} {title}
          </h2>
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="modal-body" style={{ textAlign: "center", padding: "1.5rem 2rem" }}>
          <p
            style={{
              fontSize: "1.1rem",
              color: "var(--text-primary)",
              lineHeight: "1.6",
            }}
          >
            {message}
          </p>
        </div>
        <div className="modal-footer" style={{ gap: "1rem" }}>
          <button className="btn btn-secondary" onClick={onClose} style={{ flex: 1, textAlign: "center", alignItems: "center", justifyContent: "center" }}>
            {cancelText}
          </button>
          <button
            className={`btn ${isDanger ? "btn-danger" : "btn-primary"}`}
            onClick={() => {
              onConfirm();
              onClose();
            }}
            style={{ flex: 1.5, textAlign: "center", alignItems: "center", justifyContent: "center" }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
